/**
 * Constructs the full URL for an image from the backend or returns the image URL if it's already a full URL.
 * 
 * @param {string} imagePath - The path or filename of the image.
 * @returns {string} - The full URL to access the image.
 */
export const getImageUrl = (imagePath) => {
    // Check if imagePath is already a full URL
    const isFullUrl = /^https?:\/\//i.test(imagePath);

    // If it's a full URL, return it as-is; otherwise, construct the URL from the base URL
    return isFullUrl ? imagePath : `${process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000'}/${imagePath}`;
};